import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";

interface FocusDistanceSliderProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const FocusDistanceSlider: React.FC<FocusDistanceSliderProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (_event: Event, newValue: number | number[]) => {
    onChange(newValue as number);
  };

  return (
    <Box sx={{ width: "100%", px: 1 }}>
      <Typography variant="body2" gutterBottom>
        Focus Distance
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Near
        </Typography>
        <Slider
          value={value}
          onChange={handleChange}
          min={0}
          max={100}
          step={1}
          disabled={disabled}
          size="small"
          sx={{ flex: 1 }}
        />
        <Typography variant="caption" color="text.secondary">
          Far
        </Typography>
      </Box>
    </Box>
  );
};

export default FocusDistanceSlider;
